module.exports = __webpack_public_path__ + "static/media/leading-hotels.0604a29f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/leading-hotels.svg
// module id = 2537
// module chunks = 0